import Promotion from "../../../../components/company/workforce/promotion";

export default function PromotionPage(){
    return <Promotion />
}